// Le rotte di "Utenti e accessi", in un pacchetto loro: chi non amministra non scarica niente.
//
// Nell'app per telefoni non esistono. La condizione è scritta per intero: webpack la valuta in
// compilazione, e il ramo scartato non finisce nel pacchetto.
const vista = {
  panoramica: () => import(/* webpackChunkName: "accessi" */ "./views/panoramica.vue"),
  utenti: () => import(/* webpackChunkName: "accessi" */ "./views/utenti.vue"),
  utente: () => import(/* webpackChunkName: "accessi" */ "./views/utente.vue"),
  collegati: () => import(/* webpackChunkName: "accessi" */ "./views/collegati.vue"),
  collegato: () => import(/* webpackChunkName: "accessi" */ "./views/collegato.vue"),
  amministratori: () => import(/* webpackChunkName: "accessi" */ "./views/amministratori.vue"),
  spazi: () => import(/* webpackChunkName: "accessi" */ "./views/spazi.vue"),
  spazio: () => import(/* webpackChunkName: "accessi" */ "./views/spazio.vue"),
  consumi: () => import(/* webpackChunkName: "accessi" */ "./views/consumi.vue"),
  storico: () => import(/* webpackChunkName: "accessi" */ "./views/storico.vue"),
  gruppi: () => import(/* webpackChunkName: "accessi" */ "./views/gruppi.vue"),
  gruppo: () => import(/* webpackChunkName: "accessi" */ "./views/gruppo.vue"),
  matrice: () => import(/* webpackChunkName: "accessi" */ "./views/matrice.vue"),
  catalogo: () => import(/* webpackChunkName: "accessi" */ "./views/catalogo.vue"),
  verifica: () => import(/* webpackChunkName: "accessi" */ "./views/verifica.vue"),
  rilasci: () => import(/* webpackChunkName: "accessi" */ "./views/rilasci.vue"),
  serveApp: () => import(/* webpackChunkName: "accessi" */ "./views/serve-app.vue"),
};

/** Una rotta dell'app. `props: true` sulle schede: l'identificativo arriva come proprietà. */
function rotta(percorso, nome, titolo, componente, props = false) {
  return {
    path: `/accessi${percorso}`,
    name: `accessi-${nome}`,
    meta: { title: titolo, authRequired: true },
    component: componente,
    props,
  };
}

export default process.env.VUE_APP_PIATTAFORMA === "mobile"
  ? []
  : [
    { path: "/accessi", redirect: "/accessi/panoramica" },
    rotta("/panoramica", "panoramica", "Panoramica", vista.panoramica),
    rotta("/utenti", "utenti", "Utenti", vista.utenti),
    rotta("/utenti/:id", "utente", "Scheda utente", vista.utente, true),
    rotta("/collegati", "collegati", "Utenti collegati", vista.collegati),
    rotta("/collegati/:id", "collegato", "Attività", vista.collegato, true),
    rotta("/amministratori", "amministratori", "Amministratori", vista.amministratori),
    rotta("/spazi", "spazi", "Spazi", vista.spazi),
    rotta("/spazi/:id", "spazio", "Scheda spazio", vista.spazio, true),
    rotta("/consumi", "consumi", "Consumi", vista.consumi),
    rotta("/gruppi", "gruppi", "Gruppi", vista.gruppi),
    rotta("/gruppi/:id", "gruppo", "Gruppo", vista.gruppo, true),
    rotta("/matrice", "matrice", "Matrice", vista.matrice),
    rotta("/catalogo", "catalogo", "Catalogo", vista.catalogo),
    rotta("/verifica", "verifica", "Verifica accesso", vista.verifica),
    rotta("/storico", "storico", "Storico", vista.storico),
    rotta("/rilasci", "rilasci", "Note di rilascio", vista.rilasci),
    rotta("/serve-app", "serve-app", "Serve l'app di autenticazione", vista.serveApp),
  ];
